import React from 'react'
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import Modal from '@mui/material/Modal';
import DeleteIcon from '@mui/icons-material/Delete';

import TextField from '@mui/material/TextField';

import CloseIcon from '@mui/icons-material/Close';

export default function TimesheetDailyENG({ weekData = [], refreshPostUpdate }) {

  const [submitted, setSubmitted] = React.useState("");
  // Styles for the edit modal
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    fontFamily: 'Montserrat',
    fontWeight: "bold",
  };

  // State to control the visibility of the edit modal
  const [editModalOpen, setEditModalOpen] = React.useState(false);
  // Function to close the edit modal
  const handleModalClose = () => {
    setEditModalOpen(false)
    setSubmitted("")
    refreshPostUpdate();
  };

  // State to keep track of the selected job for editing
  const [selectedJob, setSelectedJob] = React.useState(null);

  // References to store current values of each input in the edit modal
  const revisedStartRef = React.createRef();
  const revisedEndRef = React.createRef();
  const revisedLunchRef = React.createRef();
  const revisedTotalHoursRef = React.createRef();
  const revisedJobNumRef = React.createRef();
  const revisedJobDescRef = React.createRef();

  // Function to open the edit modal with the selected job's details
  const handleModalRender = (jobNum, jobDesc, startTime, endTime, lunch, totalHours, jobID, fullName, date, rowID) => {
    setSelectedJob({
      jobNumber: jobNum,
      jobDescription: jobDesc,
      startTime: startTime,
      endTime: endTime,
      lunch: lunch,
      total: totalHours,
      fullName: fullName,
      jobID: jobID,
      date: date,
      rowID: rowID
    }, () => setEditModalOpen(true));
  }

  // Function to post the edited timesheet data to the backend

  const calculateNewTotalHoursPerJob = (timeStart, timeEnd, lunchTime) => {
    // set a same arbitrary date for both times
    const dateBase = "2000-01-01 ";

    // create Date objects
    const dateStart = new Date(dateBase + timeStart);
    const dateEnd = new Date(dateBase + timeEnd);

    // calculate the difference in milliseconds
    const differenceInMs = dateEnd - dateStart;

    // calculate the difference in hours (as a decimal)
    var differenceInHours = (differenceInMs / (1000 * 60 * 60));
    
    // If it is NOT, NOT a number, it is a number
    if (!isNaN(lunchTime)) {
      differenceInHours -= parseFloat(lunchTime);
    }
    
    return differenceInHours;
  }

  const postRevisedToDB = async (newJobNum, newJobDesc, newStart, newEnd, newLunch, newTotalHours) => {
    const targetRowID = await selectedJob.rowID;
    const targetJobID = await selectedJob.jobID;
    const trueTotalHours = await calculateNewTotalHoursPerJob(newStart, newEnd, newLunch);
    // await setSelectedJob(prevSelectedJob => ({
    //   ...prevSelectedJob,  // keep all the other key-value pairs
    //   total: newTotalHours  // update just the totalHours
    // }));

    const newData = await [`${newJobNum}`, `${newJobDesc}`, `${newStart}`, `${newEnd}`, `${newLunch}`, `${trueTotalHours}`]

    setSubmitted("Updated Successfully")
    await fetch('https://ic360portalbackend.azurewebsites.net/api/ENG/Timesheets/updateTimesheet', {
      method: 'POST',
      headers: {
        'Content-type': 'application/JSON',
      },
      body: JSON.stringify({
        newData: newData,
        targetRowID: targetRowID,
        targetJobID: targetJobID
      })
    })
      .then(response => response.json())
      .then(data => {
        // console.log(data)
      })
  }

  // Function to handle the submission of edited data
  const handleRevisionSubmit = () => {
    const revisedStart = revisedStartRef.current.value;
    const revisedEnd = revisedEndRef.current.value;
    const revisedLunch = revisedLunchRef.current.value;
    const revisedTotalHours = revisedTotalHoursRef.current.value;
    const revisedJobNum = revisedJobNumRef.current.value;
    const revisedJobDesc = revisedJobDescRef.current.value;

    postRevisedToDB(revisedJobNum, revisedJobDesc, revisedStart, revisedEnd, revisedLunch, revisedTotalHours)
  }

  // Effect to open the edit modal when a job is selected
  React.useEffect(() => {
    if (selectedJob) {
      setEditModalOpen(true);
    }
  }, [selectedJob]);

  // Styles for the delete modal
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  // State to control the visibility of the delete modal
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);
  // State to keep track of the ID of the timesheet entry to be deleted
  const [deleteID, setDeleteID] = React.useState(null);
  const [deleteName, setDeleteName] = React.useState(null);
  const [deleteDate, setDeleteDate] = React.useState(null);

  const [deleteStatus, setDeleteStatus] = React.useState("");

  // Function to close the delete modal and reset the ID
  const handleDeleteModalClose = () => {
    setDeleteModalOpen(false)

    setDeleteName(null)
    setDeleteDate(null)
    setDeleteID(null)

    refreshPostUpdate();
  };

  // Function to open the delete modal with the selected timesheet ID
  const handleDeleteModalRender = (timesheetID, employeeName, timesheetDate) => {
    setDeleteID(timesheetID);
    setDeleteName(employeeName);
    setDeleteDate(timesheetDate)
    setDeleteModalOpen(true);
  };

  // Function to delete timesheet based on ID in the backend
  const handleDeleteInDB = async (timesheetID) => {

    setDeleteStatus("Deleted Successfully")
    try {
      // Send a DELETE request to the backend
      // https://ic360portalbackend.azurewebsites.net
      const response = await fetch(`https://ic360portalbackend.azurewebsites.net/api/ENG/Timesheets/deleteTimesheet/${timesheetID}`, {
        method: 'DELETE',
        headers: {
          'Content-type': 'application/JSON',
        },
      });

      // Check if the response status indicates a successful request
      if (!response.ok) {
        throw new Error(response.statusText);
      }

      const data = await response.json();

    } catch (error) {
      console.error("There was an error deleting the timesheet:", error);
    }

  }

  const calculateJobHours = (timesheetData) => {
    var newTotal = 0
    for(var i = 0; i < timesheetData.length; i++) {
      if (i !== timesheetData.length - 1) {
        newTotal += parseFloat(timesheetData[i].totalHours)
      }
    }

    return newTotal
  }
  // The Row function represents a single row in a table and is responsible for 
  // displaying timesheet data, deletion, and editing modals.
  function Row() {
    // State variable to track if the row details are expanded or collapsed.
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        {/* Delete Modal */}
        <Modal
          open={deleteModalOpen}
          onClose={handleDeleteModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ color: "tomato", fontFamily: "Montserrat", fontWeight: "bold" }}>
              Are you sure you want to delete
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Deleting timesheet
              <br />
              <Typography sx={{ fontWeight: "bold" }}>{deleteName} - {deleteDate}</Typography>
            </Typography>
            {/* Confirm Deletion Button */}
            <Button
              sx={{
                color: "white",
                marginTop: "20px",
                background: "tomato",
                fontFamily: 'Montserrat',
                fontWeight: 'bold',
                '&:hover': {
                  background: "#333333",
                  color: "white"
                }
              }}
              onClick={() => handleDeleteInDB(deleteID)}
            >Confirm
            </Button>
            
            <Button
              sx={{
                color: "black",
                marginTop: "20px",
                marginLeft: "10px",
                background: "white",
                fontFamily: 'Montserrat',
                fontWeight: 'bold',
                border: "1px solid #333333",
                '&:hover': {
                  background: "lightgrey",
                }
              }}
              onClick={() => handleDeleteModalClose()}
            >Cancel
            </Button>

            <div style={{color:"#43A047", marginTop:"2vh", fontWeight: "bold"}}>{deleteStatus}</div>
          </Box>
        </Modal>

        {/* Editing Modal */}
        <Modal
          open={editModalOpen}
          onClose={handleModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modalStyle}>
            <div className="timesheet-modal">

              <div style={{ fontSize: "1.5rem" }}>
                {selectedJob && selectedJob.fullName} - {selectedJob && selectedJob.date}
                <IconButton sx={{ float: "right", color: 'tomato' }}> <CloseIcon onClick={handleModalClose} />  </IconButton>
              </div>
              <div className="timesheet-modal-details">
                <div className=""> Job Number: <span style={{ color: "tomato" }}>{selectedJob && selectedJob.jobNumber}</span>&nbsp; |
                  Job Desc: <span style={{ color: "tomato" }}>{selectedJob && selectedJob.jobDescription}</span>
                </div>
                <div className="">
                  Start: <span style={{ color: "tomato" }}>{selectedJob && selectedJob.startTime}</span>&nbsp; |
                  End: <span style={{ color: "tomato" }}>{selectedJob && selectedJob.endTime}</span>&nbsp; |
                  Lunch: {selectedJob ?
                    (
                      selectedJob.lunch === "0" || selectedJob.lunch === 0 ?
                        <>
                          <span style={{ color: "tomato" }}>0</span>
                        </>
                        :
                        <>
                          <span style={{ color: "tomato" }}>{selectedJob.lunch}</span>
                        </>
                    ) :
                    <>
                      Loading
                    </>}&nbsp;
                </div>


                Total Hours: <span style={{ color: "tomato" }}>{selectedJob && selectedJob.total}</span>&nbsp;
              </div>

              <div className='timesheet-modal-entry'>
                <TextField
                  label="Revised Job Number"
                  defaultValue={selectedJob && selectedJob.jobNumber ? selectedJob.jobNumber : "N/A"}
                  variant="outlined"
                  inputRef={revisedJobNumRef}
                  InputLabelProps={{
                    sx: {
                      '&.Mui-focused + .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'tomato',
                      },
                      '&&.Mui-focused': {
                        color: 'tomato',
                      }
                    }
                  }}
                /> &nbsp;
                <TextField
                  label="Revised Job Desc"
                  defaultValue={selectedJob && selectedJob.jobDescription ? selectedJob.jobDescription : "N/A"}
                  variant="outlined"
                  inputRef={revisedJobDescRef}
                  InputLabelProps={{
                    sx: {
                      '&.Mui-focused + .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'tomato',
                      },
                      '&&.Mui-focused': {
                        color: 'tomato',
                      }
                    }
                  }}
                /> &nbsp;
              </div>
              <hr />
              <div className="timesheet-modal-entry">
                <TextField
                  label="Revised Start"
                  defaultValue={selectedJob && selectedJob.startTime ? selectedJob.startTime : "N/A"}
                  variant="outlined"
                  inputRef={revisedStartRef}
                  InputLabelProps={{
                    sx: {
                      '&.Mui-focused + .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'tomato',
                      },
                      '&&.Mui-focused': {
                        color: 'tomato', // color when focused
                      }
                    }
                  }}
                /> &nbsp;
                <TextField
                  label="Revised End"
                  defaultValue={selectedJob && selectedJob.endTime ? selectedJob.endTime : "N/A"}
                  variant="outlined"
                  inputRef={revisedEndRef}
                  InputLabelProps={{
                    sx: {
                      '&.Mui-focused + .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'tomato',
                      },
                      '&&.Mui-focused': {
                        color: 'tomato', // color when focused
                      }
                    }
                  }}
                /> &nbsp;


                <TextField
                  label="Revised Lunch"
                  defaultValue={selectedJob && selectedJob.lunch ? selectedJob.lunch : "N/A"}
                  variant="outlined"
                  inputRef={revisedLunchRef}
                  InputLabelProps={{
                    sx: {
                      '&.Mui-focused + .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'tomato',
                      },
                      '&&.Mui-focused': {
                        color: 'tomato',
                      }
                    }
                  }}
                /> &nbsp;
                <TextField
                  label="Revised Total Hours"
                  defaultValue={selectedJob && selectedJob.total}
                  variant="outlined"
                  inputRef={revisedTotalHoursRef}
                  InputLabelProps={{
                    sx: {
                      '&.Mui-focused + .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'tomato',
                      },
                      '&&.Mui-focused': {
                        color: 'tomato',
                      }
                    }
                  }}
                /> &nbsp;
              </div>
            </div>

            <Button
              variant='contained'
              sx={{
                color: "white",
                marginTop: "20px",
                background: "tomato",
                fontFamily: 'Montserrat',
                fontWeight: 'bold',
                '&:hover': {
                  background: "#333333",
                  color: "white"
                }
              }}
              onClick={handleRevisionSubmit}
            >
              submit
            </Button>
            <div style={{color:"#43A047", marginTop:"2vh"}}>{submitted}</div>
          </Box>
        </Modal>

        {/* Main Table Row */}
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell sx={{ width: "60px", marginRight: "0px", paddingRight: "0px" }}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton >
          </TableCell>
          <TableCell sx={{ marginLeft: "0px", paddingLeft: "0px" }}>
            <Typography fontWeight="bold" fontSize='1rem'>
              Employee Timesheets
            </Typography>
          </TableCell>
        </TableRow>

        {/* Collapsible Details Row */}
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>

              {weekData.map((timesheetEntry, index) =>
                <>
                  <Box sx={{ margin: 1 }}>
                    <Typography variant="h6" gutterBottom component="span" sx={{ color: "tomato", fontWeight: "bold" }}>
                      {timesheetEntry.FullName} - {timesheetEntry.Date}
                    </Typography>
                    {/* Button for deleting an entire timesheet */}
                    <Button
                      variant='outlined'
                      sx={{
                        float: "right",
                        color: "black",
                        borderColor: "black",
                        fontFamily: "Roboto",
                        fontWeight: "Bold",
                        '&:hover': {
                          background: "red",
                          color: "white",
                          borderColor: "red"
                        }
                      }}
                      onClick={() => handleDeleteModalRender(timesheetEntry.id, timesheetEntry.FullName, timesheetEntry.Date)}
                    >  DELETE <DeleteIcon sx={{ paddingBottom: "5px" }} />
                    </Button>
                    <Table size="small">
                      <TableHead >
                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold', width: "15%" }}>Job Number</TableCell>
                          <TableCell sx={{ fontWeight: 'bold', width: "20%" }}>Job Desc</TableCell>
                          <TableCell sx={{ fontWeight: 'bold', width: "15%" }}>Start</TableCell>
                          <TableCell sx={{ fontWeight: 'bold', width: "15%" }}>End</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold', width: '5%' }}>Lunch</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold', width: "20%" }}>Total Hours</TableCell>
                          <TableCell align="right" sx={{ width: "5%" }}></TableCell>
                        </TableRow>
                      </TableHead>

                      {
                        timesheetEntry.jobDetails.map((job, index, jobDetails) => (
                          <>
                            {
                              job.totalHours === "0" ? <></>
                                :
                                <>
                                  {index === (jobDetails.length - 1) ?
                                    <TableBody>
                                      <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell align="right"></TableCell>
                                        <TableCell align="right"></TableCell>
                                        <TableCell align="right"></TableCell>
                                        <TableCell align="right"><b className='timesheet-card-text-orange'>Daily Total: </b> <b>{calculateJobHours(timesheetEntry.jobDetails)}</b></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                      </TableRow>
                                    </TableBody>
                                    :
                                    <TableBody>
                                      <TableRow>
                                        <TableCell>{job.jobNumber}</TableCell>
                                        <TableCell>{job.jobDescription}</TableCell>
                                        <TableCell>{job.startTime}</TableCell>
                                        <TableCell>{job.endTime}</TableCell>
                                        <TableCell align="center">{job.lunch === '0' || job.lunch === '0' || job.lunch === "N/A" ? <>N</> : <>{job.lunch}</>}</TableCell>
                                        <TableCell align="right">{job.totalHours}</TableCell>
                                        <TableCell>
                                          <Button
                                            sx={{
                                              color: 'tomato',
                                              padding: '0',
                                              marginLeft: '5px',
                                              textTransform: "none"
                                            }}
                                            onClick={() =>
                                              handleModalRender(job.jobNumber, job.jobDescription, job.startTime, job.endTime, job.lunch, job.totalHours, job.id, timesheetEntry.FullName, timesheetEntry.Date, timesheetEntry.id)
                                            }
                                          >
                                            <EditIcon sx={{ fontSize: "1rem", paddingRight: "5px" }} /> edit
                                          </Button>
                                        </TableCell>
                                      </TableRow>
                                    </TableBody>
                                  }
                                </>
                            }
                          </>
                        ))
                      }
                    </Table>
                  </Box>
                </>
              )}

            </Collapse>
          </TableCell>
        </TableRow>

          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}> 
            <Collapse in={open} timeout="auto" unmountOnExit>
              
            </Collapse>
          </TableCell>
        <TableRow>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableBody>
            <Row />
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
